module.exports = __webpack_public_path__ + "static/media/arrow-small.198f3eb5.svg";